import React from "react";
import SectionHeader from "./SectionHeader";
import OffersSection from "../../../shared/components/casino/OffersSection";

/**
 * Special Offers row. Rendered only when featured offers exist (the parent
 * gates on useSpecialOffersAvailable). OffersSection fetches and renders the
 * offer cards itself; this is the header + layout wrapper.
 *
 * Module-scope component (was inline in GameLobby's render body).
 */
const SpecialOffersSection = ({ navigate }) => (
  <section className="mb-12">
    <SectionHeader title="Special Offers" onViewAll={() => navigate("/offers")} />

    <OffersSection
      title=""
      description=""
      limit={3}
      mobileLimit={2}
      featuredOnly={true}
      showViewAll={false}
      className="py-0"
      gridCols="grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
    />
  </section>
);

export default SpecialOffersSection;
